//#region src/__generated__/filesystem-gge/documents/types/FileMetaDto.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSourceTypeEnum = {
	PROJECT_ID: "PROJECT_ID",
	WORK_GROUP: "WORK_GROUP",
	MODEL_REPOSITORY: "MODEL_REPOSITORY",
	CONTRACTOR_MANAGEMENT: "CONTRACTOR_MANAGEMENT",
	COSMOS: "COSMOS",
	COSMOS_FOR_DELETE: "COSMOS_FOR_DELETE",
	COSMOS_FOR_MIGRATE: "COSMOS_FOR_MIGRATE",
	ONTOLOGY_FILE_UPLOAD: "ONTOLOGY_FILE_UPLOAD",
	CLASSIFIER_TABLE_ROW: "CLASSIFIER_TABLE_ROW",
	ONTOLOGY_CLASSIFIER_TABLE: "ONTOLOGY_CLASSIFIER_TABLE",
	ONTOLOGY_CATALOG_DEFINITION: "ONTOLOGY_CATALOG_DEFINITION",
	ONTOLOGY_SFO_DEFINITION: "ONTOLOGY_SFO_DEFINITION",
	MODEL_PROPERTIES: "MODEL_PROPERTIES",
	KNOWLEDGE_BASE: "KNOWLEDGE_BASE",
	REPORT_GENERATION_CACHE: "REPORT_GENERATION_CACHE"
};
const fileMetaDtoTypeEnum = {
	DIRECTORY: "DIRECTORY",
	DOCUMENT: "DOCUMENT",
	CLASSIFIER_DOCUMENT: "CLASSIFIER_DOCUMENT",
	MODEL: "MODEL",
	MODEL_DATA: "MODEL_DATA",
	MODEL_DATA_SIMPLIFIED: "MODEL_DATA_SIMPLIFIED",
	IMAGE: "IMAGE",
	COMMENT_DOCUMENT: "COMMENT_DOCUMENT",
	COSMOS_DOCUMENT: "COSMOS_DOCUMENT",
	COSMOS_GEOSERVER_DOCUMENT: "COSMOS_GEOSERVER_DOCUMENT",
	BUILDING_MANAGEMENT_DOCUMENT: "BUILDING_MANAGEMENT_DOCUMENT",
	TASK_TRACKER: "TASK_TRACKER",
	MODEL_REPOSITORY: "MODEL_REPOSITORY",
	CONTRACTOR_MANAGEMENT: "CONTRACTOR_MANAGEMENT",
	ONTOLOGY_DOCUMENT: "ONTOLOGY_DOCUMENT",
	COLLISION_DOCUMENT: "COLLISION_DOCUMENT",
	KNOWLEDGE_BASE_DOCUMENT: "KNOWLEDGE_BASE_DOCUMENT",
	REPORT_GENERATION_CACHE: "REPORT_GENERATION_CACHE",
	PDF_DOCUMENT: "PDF_DOCUMENT",
	PDF_DOCUMENT_PREVIEW: "PDF_DOCUMENT_PREVIEW"
};
//#endregion
//#region src/__generated__/filesystem-gge/documents/types/Update7.ts
const update7ProcessTask = {
	CLASSIFIER_DATA: "CLASSIFIER_DATA",
	DICTIONARY_DATA: "DICTIONARY_DATA",
	DOCUMENT: "DOCUMENT",
	DICTIONARY_CALC_COST: "DICTIONARY_CALC_COST",
	DICTIONARY_CALC_CALENDAR: "DICTIONARY_CALC_CALENDAR",
	BUILDING_MANAGEMENT: "BUILDING_MANAGEMENT",
	KNOWLEDGE_BASE_DOCUMENT: "KNOWLEDGE_BASE_DOCUMENT",
	TASK_TRACKER_DEFAULT: "TASK_TRACKER_DEFAULT"
};
//#endregion
//#region src/__generated__/filesystem-gge/documents/types/Upload7.ts
const upload7ProcessTask = {
	CLASSIFIER_DATA: "CLASSIFIER_DATA",
	DICTIONARY_DATA: "DICTIONARY_DATA",
	DOCUMENT: "DOCUMENT",
	DICTIONARY_CALC_COST: "DICTIONARY_CALC_COST",
	DICTIONARY_CALC_CALENDAR: "DICTIONARY_CALC_CALENDAR",
	BUILDING_MANAGEMENT: "BUILDING_MANAGEMENT",
	KNOWLEDGE_BASE_DOCUMENT: "KNOWLEDGE_BASE_DOCUMENT",
	TASK_TRACKER_DEFAULT: "TASK_TRACKER_DEFAULT"
};
//#endregion
export { fileMetaDtoTypeEnum as i, update7ProcessTask as n, fileMetaDtoSourceTypeEnum as r, upload7ProcessTask as t };

//# sourceMappingURL=Upload72.js.map